import * as React from 'react';
import { connect } from 'react-redux';
import { navigateTo } from '../../../actions/navigationActions';
import { redirectToUrl } from '../../../actions/sspActions';
import { DASHBOARD } from '../../../routes/routes';
import './Payment.css';

class PaymentSuccess extends React.Component<any, any> {
    constructor(props) {
        super(props);

        this.handleBackHome = this.handleBackHome.bind(this);
    }

    handleBackHome() {
        if (this.props.ssp.paymentPortalOnly) {
            this.props.dispatchAction(redirectToUrl(this.props.ssp.portalRedirectUrl));
        } else {
            this.props.dispatchAction(navigateTo(DASHBOARD));
        }
    }

    public render() {
        return (
            <div id="PaymentContainer" className="pt-lg-5 p-lg-0 logged-out">
                <div className="notice-container green">
                    <div className="notice-container-content row">
                        <div className="col-md-6 offset-md-3 text-center">
                            <div>
                                <img src="./images/payment/payment-success-icon.svg" alt="Success" />
                            </div>
                            <div className="notice-text mt-4">
                                Your payment was successful
                            </div>
                            <div>
                                <button onClick={this.handleBackHome} className="btn btn-outline-white btn-responsive btn-lg">Done</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        ssp: state.ssp,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentSuccess);